import { useEffect } from "react";
import { Building2, Phone, Mail, MapPin, Clock } from "lucide-react";

// Standalone Eurogulf Mobility Group corporate placeholder.
// Intentionally NOT linked from the customer site navigation.
export default function Egmg() {
  useEffect(() => {
    document.title = "Eurogulf Mobility Group";
  }, []);

  return (
    <div className="min-h-screen bg-[#0B1F16] text-white flex flex-col" data-testid="egmg-page">
      {/* subtle backdrop */}
      <div className="pointer-events-none fixed inset-0 opacity-[0.06]"
        style={{ backgroundImage: "radial-gradient(circle at 20% 20%, #7AB800 0, transparent 45%), radial-gradient(circle at 80% 80%, #009900 0, transparent 45%)" }} />

      <header className="relative z-10 px-6 sm:px-10 py-6 flex items-center gap-3 border-b border-white/10">
        <div className="w-11 h-11 rounded-xl bg-[#009900] flex items-center justify-center shrink-0">
          <Building2 className="w-6 h-6 text-white" />
        </div>
        <div>
          <div className="text-sm font-bold tracking-wide leading-tight">Eurogulf Mobility Group</div>
          <div className="text-[11px] uppercase tracking-[0.22em] text-[#7AB800]">Corporate</div>
        </div>
      </header>

      <main className="relative z-10 flex-1 px-6 sm:px-10 py-16 sm:py-24 max-w-4xl mx-auto w-full">
        <span className="inline-block text-[11px] uppercase tracking-[0.22em] text-[#7AB800] font-semibold" data-testid="egmg-eyebrow">
          Corporate site
        </span>
        <h1 className="mt-4 text-4xl sm:text-5xl font-bold leading-tight" data-testid="egmg-heading">
          Eurogulf Mobility Group
        </h1>
        <p className="mt-5 text-white/70 text-base leading-relaxed max-w-2xl" data-testid="egmg-intro">
          A dedicated corporate home for Eurogulf Mobility Group is on the way. This is a placeholder
          while the full site is prepared. In the meantime, our corporate team is reachable on the
          line below.
        </p>

        <div className="mt-12 grid sm:grid-cols-2 gap-5 max-w-2xl">
          <div className="rounded-2xl border border-white/10 bg-white/[0.04] p-6" data-testid="egmg-contact-phone">
            <Phone className="w-5 h-5 text-[#7AB800]" />
            <div className="mt-3 text-xs uppercase tracking-wide text-white/50">Corporate line</div>
            <div className="text-lg font-semibold mt-1">800 364</div>
          </div>
          <div className="rounded-2xl border border-white/10 bg-white/[0.04] p-6" data-testid="egmg-contact-email">
            <Mail className="w-5 h-5 text-[#7AB800]" />
            <div className="mt-3 text-xs uppercase tracking-wide text-white/50">Corporate enquiries</div>
            <div className="text-lg font-semibold mt-1">info@eurogulfmobility.com</div>
          </div>
          <div className="rounded-2xl border border-white/10 bg-white/[0.04] p-6" data-testid="egmg-contact-address">
            <MapPin className="w-5 h-5 text-[#7AB800]" />
            <div className="mt-3 text-xs uppercase tracking-wide text-white/50">Head office</div>
            <div className="text-base font-medium mt-1 leading-snug">Al Quoz Industrial Area 1, Dubai, UAE</div>
          </div>
          <div className="rounded-2xl border border-white/10 bg-white/[0.04] p-6" data-testid="egmg-contact-hours">
            <Clock className="w-5 h-5 text-[#7AB800]" />
            <div className="mt-3 text-xs uppercase tracking-wide text-white/50">Office hours</div>
            <div className="text-base font-medium mt-1">Sunday to Thursday, 09:00 to 18:00</div>
          </div>
        </div>
      </main>

      <footer className="relative z-10 px-6 sm:px-10 py-6 border-t border-white/10 text-[11px] text-white/40">
        © {new Date().getFullYear()} Eurogulf Mobility Group. All rights reserved.
      </footer>
    </div>
  );
}
